const colors = [
  'bg-green-500', 'bg-blue-500', 'bg-purple-500',
  'bg-yellow-500', 'bg-red-500', 'bg-pink-500',
  'bg-indigo-500', 'bg-teal-500',
]

export default function RegionBreakdown({ members }) {
  const regionCounts = {}
  members.forEach(m => {
    const region = m.region || 'Unknown'
    regionCounts[region] = (regionCounts[region] || 0) + 1
  })

  const sorted = Object.entries(regionCounts)
    .map(([region, count]) => ({ region, count }))
    .sort((a, b) => b.count - a.count)

  const total = members.length || 1
  const maxCount = Math.max(...sorted.map(r => r.count), 1)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Geographic Spread
      </div>
      {sorted.length === 0 ? (
        <div className="text-gray-400 text-sm">No region data available</div>
      ) : (
        <div className="flex flex-col gap-3">
          {sorted.map(({ region, count }, index) => {
            const percentage = Math.round((count / total) * 100)
            return (
              <div key={region}>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm font-semibold text-gray-900 dark:text-white">{region}</span>
                  <span className="text-gray-500 text-xs">{count} members ({percentage}%)</span>
                </div>
                <div className="bg-gray-200 dark:bg-white/10 h-2">
                  <div
                    className={`${colors[index % colors.length]} h-2 transition-all`}
                    style={{ width: `${(count / maxCount) * 100}%` }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-white/10">
        <div className="text-xs text-gray-500">
          {sorted.length} regions represented across {total} members
        </div>
      </div>
    </div>
  )
}